module.exports = __webpack_public_path__ + "media/svg-new/philosophy-ead6027e.svg";